import { isApiError } from '@/helpers/apiClient'

/**
 * Whether a failed session check means the token itself was refused. The API's
 * guards answer an invalid or revoked token with 401 or 403; anything else (a
 * network error, a 5xx during a deploy) says nothing about the token.
 */
export function isSessionRejected<E>(error: E): boolean {
  return isApiError(error) && (error.status === 401 || error.status === 403)
}
